import { Flex, Spinner, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

function LoadingScreen() {
  const { t } = useTranslation('common');

  return (
    <Flex display="flex" alignItems="center" justifyContent="center" h="100%">
      <VStack gap={4}>
        <Spinner size="xl" color="sindiPurple.600" animationDuration="0.8s" />
        <Text color="gray.500">{t('loading')}</Text>
      </VStack>
    </Flex>
  );
}

export default LoadingScreen;
